module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10233.b05da1e3.jpg";